<Page name="about" 
  infinite
  infiniteDistance={30}
  infinitePreloader={showPreloader}
  onInfinite={loadMore}>
  <Header />
  <BlockTitle>About Prevention TaskForce</BlockTitle>
  <Card>
    <CardContent>
    <p>The U.S. Preventive Services Task Force (USPSTF or Task Force), an independent body of experts in preventive medicine and primary care, works to improve the health of all Americans by making evidence-based recommendations about the effectiveness of clinical preventive services and health promotion. The recommendations made by the USPSTF address clinical preventive services for adults and children, and include screening tests, counseling services, and preventive medications. The Task Force makes its recommendations based on comprehensive, systematic reviews and careful assessment of the available medical evidence.</p>
    <p>The USPSTF comprises 16 volunteer members who are nationally recognized experts in the disciplines of preventive medicine and primary care, including internal medicine, family medicine, geriatrics, pediatrics, preventive medicine, behavioral medicine, public health, obstetrics and gynecology, and nursing. All members volunteer their time to serve on the USPSTF, and most are practicing clinicians.</p>
    <p>Since its inception over 25 years ago, the USPSTF has worked to improve the health of all Americans by making evidence-based recommendations about clinical preventive services and health promotion. The USPSTF makes recommendations based on scientific evidence about the effectiveness of each service. These recommendations are primarily directed to the primary care professional who delivers these services. USPSTF recommendations are also used by individuals and families as they make decisions about their own health and health care, and by health care organizations as they consider their policies.</p>
    <p>USPSTF recommendations apply to preventive services that are offered in a primary care setting (such as a Pap smear to detect cervical cancer), services that are available through primary care referral (such as a colonoscopy to detect colorectal cancer), or behavioral counseling programs (such as counseling to help reduce obesity). USPSTF recommendations apply to people who have no signs or symptoms of a disease or condition.</p>
    <p>Every USPSTF recommendation is based on a rigorous, systematic review of the scientific evidence published in peer-reviewed journals. To make its recommendations, the USPSTF evaluates the potential benefits and harms of clinical preventive services. When appropriate and when evidence exists, the Task Force evaluates the potential benefits and harms based on age, sex, and risk factors for disease. The potential benefits of preventive services include early identification of disease and improvement in health outcomes. The potential harms of preventive services can include adverse effects of the service itself or inaccurate test results that lead to a cascade of additional testing, some with attendant risks, or unneeded treatment.</p>
    <p>The USPSTF regularly prioritizes new clinical preventive service topics and topics for updating based on public input and new evidence. The steps that the USPSTF takes once a topic has been selected for review are shown here.</p>
    </CardContent>
  </Card>
  <Row><Footer/></Row>
</Page>
<script>
  import {
    Page,
    Navbar,
    NavLeft,
    NavRight,
    NavTitle,
    List,
    ListGroup,
    ListItem,
    Button,
    Preloader,
    Link,
    Block,
    Row,
    Col,
    SwipeoutActions,
    SwipeoutButton,
    BlockTitle,
    Card,
    CardContent
  } from 'framework7-svelte';
  import { pluralize } from '../utils';
  import Header from '../components/Header.svelte';
  import Footer from '../components/Footer.svelte';
  import { getContext, onDestroy } from 'svelte';
  import { query, searchData } from '../stores.js';

  let page = 1;
  let items;
  let currentItem;
  let allowInfinite = true;
  let showPreloader = false;
  let sQuery = '';
  let grade;
  let isShowFilter = true;

  let oData; 
  let oFilter;

  $: showPreloader = (items) ? (items.length < 299) ? true : false : false;
  $: fGroupTools();

  const unsubscribeSearchData = searchData.subscribe(obj => {
    oData = obj;
    fGroupTools(obj);
  });

  onDestroy(unsubscribeSearchData);

  function fGroupTools(obj) {

  }

  function loadMore() {
    if (!allowInfinite) return;
    allowInfinite = false;

    if (!showPreloader) return;
    
    page += 1;
  }
</script>
<style>
</style>